/* eslint-disable @typescript-eslint/naming-convention */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { CustomFieldsOptions } from '../../../components/custom-fields/custom-fields.interface';
import { CustomersListOptions } from 'app/components/customers-list/customers-list.interface';
import { JobsListOptions } from 'app/components/jobs-list/jobs-list.interface';
import { CustomFieldGroupService } from 'app/core/services/custom_fields_group/custom_fields_group.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { OrganizationService } from 'app/core/services/organization/organization.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { forkJoin } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'organization-summary-preview',
  templateUrl: './organization-summary-preview.component.html',
  styleUrls: ['./organization-summary-preview.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection:ChangeDetectionStrategy?.OnPush
})
export class OrganizationSummaryPreviewComponent implements OnInit, OnChanges {
  @Input() organizationId: any = '';
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();

  object = Object;
  customFieldGroups: any = {};
  masterCustomFields: any[] = [];
  loaded: boolean = false;
  organizationDetails: any = {};
  customersCount: number = 0;
  jobsCount: number = 0;
  isJobHasAccess: boolean;
  hasPermissionToCreateJob: boolean;

  constructor(
    private dataCollectorService: DataCollectorService,
    private localisationService: LocalisationService,
    private utilityService: UtilityService,
    private router: Router,
    private organizationService: OrganizationService,
    private customFieldServie: CustomFieldGroupService,
    private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.localisationService.setDefaultLanguage();
    this.getOrganizationDetails();
    this.isJobHasAccess = this.utilityService.hasModuleAccess('JOB');
    this.hasPermissionToCreateJob = this.utilityService.hasPermission('job.new');
    this.changeDetectorRef.markForCheck();
  }

  closeDrawer(): void {
    this.eventEmitter.emit({ drawerClose: true });
    this.changeDetectorRef.markForCheck();
  }

  getFormattedAddress(address: any): string {
    return this.utilityService.getFormattedAddress(address);
  }

  getOrganizationDetails(): void {
    this.loaded = false;
    forkJoin([
      this.dataCollectorService.getData(this.organizationService.getOrganizationDetails(this.organizationId)),
      this.dataCollectorService.getData(this.customFieldServie.getModuleCustomFieldsUrl('PROPERTY'))])
      .subscribe(
        ([organizationDetails, customFields, jobs]: any) => {
          this.organizationDetails = organizationDetails.data;
          this.masterCustomFields = customFields.data;
          this.loaded = true;
          this.getCustomFieldGroups();
          this.changeDetectorRef.markForCheck();
        }, (_error: any) => {
          this.loaded = true;
          this.changeDetectorRef.markForCheck();
        });
  }

  getCustomFieldGroups(): void {
    this.customFieldGroups = this.customFieldServie.getCustomFieldGroups(this.masterCustomFields, this.organizationDetails.custom_fields);
    this.changeDetectorRef.markForCheck();
  }

  getCustomerListOptions(): CustomersListOptions {
    return {
      isLazyLoading: true,
      url: this.dataCollectorService.baseurl() + '/customers',
      paramObj: {
        'count': 5,
        'filter.customer_organization': this.organizationId,
        'page': 1,
        'sort': 'ASC',
        'sort_by': 'customer_first_name'
      }
    };
  }

  eventEmitHandler(event: any): void {
    if (!this.utilityService.isEmptyOrUndefined(event?.customersCount)) {
      this.customersCount = event.customersCount;
      this.changeDetectorRef.markForCheck();
    }
  }

  getJobListOptions(): JobsListOptions {
    return {
      url: this.dataCollectorService.baseurl() + '/jobs',
      paramObj: {
        'count': 5,
        'filter.customer_organization': this.organizationId,
        'page': 1,
        'sort': 'DESC',
        'sort_by': 'scheduled_start_time'
      }
    };
  }

  jobEventEmitHandler(event: any): void {
    if (!this.utilityService.isEmptyOrUndefined(event?.jobsCount)) {
      this.jobsCount = event.jobsCount;
      this.changeDetectorRef.markForCheck();
    }
  }

  createNewJob(event: any): void {
    event.stopPropagation();
    this.router.navigateByUrl('/jobs/new', {
      state: {
        action: 'clone',
        module: 'ORGANIZATION',
        uid: this.organizationId
      }
    });
  }

  getRedirectLink(): string {
    return this.utilityService.getLink('ORGANIZATION', this.organizationDetails.organization_uid);
  }

  getcustomFieldOptions(data: any): CustomFieldsOptions {
    return {
      data: data,
      displayInColumn: 1,
      extraClass: 'px-0',
      labelAlign: 'Left'
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.organizationId?.firstChange === false) {
      this.getOrganizationDetails();
      this.changeDetectorRef.markForCheck();
    }
  }
}
